import { Box, Input, Text } from '@betty/moonlight';
import { ForwardedRef, forwardRef } from 'react';
import { ManualFieldInputProps } from './ManualFieldInput.types';
import { TextInput } from 'react-native';

function ManualFieldInput(
  {
    field,
    value,
    placeholderNS,
    placeholderKey,
    editable,
    error,
    showError = true,
    image,
    onChange,
    onPressIn,
    submitBehavior,
    ...rest
  }: ManualFieldInputProps,
  ref: ForwardedRef<TextInput>,
) {
  return (
    <Box>
      <Input
        ref={ref}
        value={value}
        image={image}
        onChangeText={(text) => onChange(field, text)}
        editable={editable}
        placeholderNS={placeholderNS}
        placeholderKey={placeholderKey}
        onPressIn={onPressIn}
        submitBehavior={submitBehavior}
        error={error}
        {...rest}
      />
      {showError && error && (
        <Text color="darkSurfaceError" variant="body-m">
          {error}
        </Text>
      )}
    </Box>
  );
}

export default forwardRef(ManualFieldInput);
